<template>
  <div class="app-container">
    <div>
      <el-form :inline="true" ref="searchForm" :model="searchForm" class="search-form-inline">
        <el-form-item>
          <el-date-picker
            v-model="searchForm.start_created_at"
            type="date"
            value-format="yyyy-MM-dd"
            placeholder="开始日期"
            style="width: 150px;"
          ></el-date-picker>
          <span>—</span>
          <el-date-picker
            v-model="searchForm.end_created_at"
            type="date"
            value-format="yyyy-MM-dd"
            placeholder="结束日期"
            style="width: 150px;"
          ></el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-select v-model="searchForm.status" placeholder="订单状态" clearable style="width: 130px;">
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-input
            v-model="searchForm.out_trade_no"
            :placeholder="generateCustomizeString('orderId')"
            resize="horizontal"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-input
            v-model="searchForm.wx_nickname"
            placeholder="微信昵称"
            resize="horizontal"
            style="width: 152px;"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-input
            v-model="searchForm.phone"
            :placeholder="generateCustomizeString('phone')"
            resize="horizontal"
            style="width: 155px;"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onSearch()">{{ generateCustomizeString('search') }}</el-button>
          <el-button @click="onReset()">{{ generateCustomizeString('reset') }}</el-button>
        </el-form-item>
      </el-form>
    </div>
    <el-table
      :data="orderData"
      v-loading="orderListLoading"
      element-loading-text="Loading"
      border
      fit
      highlight-current-row
      style="margin-bottom: 20px;"
    >
      <el-table-column :label="generateCustomizeString('orderId')" prop="orderId"></el-table-column>
      <el-table-column :label="generateCustomizeString('orderCreateAt')">
        <template slot-scope="scope">
          <span>{{ scope.row.orderCreateAt | toLocalTime }}</span>
        </template>
      </el-table-column>
      <el-table-column :label="generateCustomizeString('username')">
        <template slot-scope="scope">
          <div v-if="scope.row.wechatName">{{ scope.row.wechatName }}</div>
          <div v-if="scope.row.customerName">{{ scope.row.customerName }}</div>
        </template>
      </el-table-column>
      <el-table-column :label="generateCustomizeString('consignee')">
        <template slot-scope="scope">
          <div>名字: {{ scope.row.consignee }}</div>
          <div>电话: {{ scope.row.consigneePhone }}</div>
        </template>
      </el-table-column>
      <el-table-column :label="generateCustomizeString('totalFee')" width="160">
        <template slot-scope="scope">
          <div>{{ scope.row.totalFee }}</div>
          <div>(含运费{{ scope.row.shippingFee }})</div>
        </template>
      </el-table-column>
      <el-table-column :label="generateCustomizeString('profit')" prop="profit"></el-table-column>
      <el-table-column :label="generateCustomizeString('status')" prop="orderStatus"></el-table-column>
      <!-- <el-table-column :label="generateCustomizeString('remark')">
        <template slot-scope="scope">
          <el-button size="small" @click="editRemark()">{{ generateCustomizeString('edit') }}</el-button>
          <span class="remark">{{ scope.row.message }}</span>
        </template>
      </el-table-column> -->
      <el-table-column :label="generateCustomizeString('operation')">
        <template slot-scope="scope">
          <el-button
            type="text"
            size="small"
            @click="clickView(scope.row)"
          >{{ generateCustomizeString('view') }}</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-footer style="margin-top: 50px; width: 100%;">
      <el-row type="flex">
        <el-col>
          <el-pagination
            @current-change="handleCurrentChange"
            :current-page.sync="currentPage"
            :page-size="numOfMembers"
            :total="currentTotal"
            small
            background
            layout="prev, pager, next"
            v-if="isMobile === true"
          ></el-pagination>
          <el-pagination
            @current-change="handleCurrentChange"
            :current-page.sync="currentPage"
            :page-size="numOfMembers"
            :total="currentTotal"
            background
            layout="total, prev, pager, next"
            v-else
          ></el-pagination>
        </el-col>
      </el-row>
    </el-footer>

    <el-dialog title="订单备注修改" :visible.sync="editRemarkDialogVisiable" width="90%">
      <el-form ref="remarkForm" :model="remarkForm" label-width="68px">
        <el-form-item label="修改备注" prop="name">
          <el-input v-model="remarkForm.remark" style="max-width: 320px;"></el-input>
        </el-form-item>
        <div style="margin-top: 50px;">
          <el-button @click="editRemarkDialogVisiable = false">取消</el-button>
          <el-button type="primary" @click="editRemarkDialogVisiable = false">修改</el-button>
        </div>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import { generateCustomizeString } from '@/utils/i18n'
import request from '@/utils/request'
import dayjs from 'dayjs'

const originOrderSearchFrom = {
  start_created_at: '',
  end_created_at: '',
  out_trade_no: '',
  status: '',
  wx_nickname: '',
  phone: ''
}

export default {
  name: 'OrderList',
  data() {
    return {
      orderListLoading: false,
      searchForm: Object.assign({}, originOrderSearchFrom),
      editRemarkDialogVisiable: false,
      currentPage: 1,
      currentTotal: 0,
      numOfMembers: 15,
      filters: {},
      order_by: 'created_at_asc',
      orderData: [],
      remarkForm: {
        remark: ''
      },
      isMobile: false,
      options: [{
        value: 0,
        label: '未付款'
      }, {
        value: 5,
        label: '部分付款'
      }, {
        value: 10,
        label: '已付款'
      }, {
        value: 15,
        label: '配货中'
      }, {
        value: 20,
        label: '已发货'
      }, {
        value: 40,
        label: '交易完成'
      }, {
        value: 50,
        label: '申请退款'
      }, {
        value: 60,
        label: '退款完成'
      }, {
        value: 90,
        label: '已关闭'
      }]
    }
  },
  created() {
    this.fetchOrderData(1)
    this.checkMobile()
  },
  methods: {
    generateCustomizeString,
    checkMobile() {
      if (/Android|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent)) {
        this.isMobile = true
      }
    },
    getLocalTime(date, i) {
      // 参数i为时区值数字，比如北京为东八区则输进8,西5输入-5
      if (typeof i !== 'number') return
      var d = new Date(date)
      // 得到1970年一月一日到现在的秒数
      var len = d.getTime()
      // 本地时间与GMT时间的时间偏移差
      var offset = d.getTimezoneOffset() * 60000
      // 得到现在的格林尼治时间
      var utcTime = len + offset
      return new Date(utcTime - 3600000 * i)
    },
    onSearch() {
      this.$refs.searchForm.validate(valid => {
        if (valid) {
          const params = Object.assign({}, this.searchForm)
          var startDate = this.searchForm.start_created_at
          var endDate = this.searchForm.end_created_at
          if (startDate) {
            startDate = startDate + ' 00:00:00'
            startDate = new Date(startDate).getTime()
            startDate = this.getLocalTime(startDate, 0)
            startDate = dayjs(new Date(startDate)).format('YYYY-MM-DD HH:mm:ss')
          }
          if (endDate) {
            endDate = endDate + ' 23:59:59'
            endDate = new Date(endDate).getTime()
            endDate = this.getLocalTime(endDate, 0)
            endDate = dayjs(new Date(endDate)).format('YYYY-MM-DD HH:mm:ss')
          }
          params.start_created_at = startDate
          params.end_created_at = endDate
          this.filters = params
          this.fetchOrderData(1)
        } else {
          console.log('data error')
        }
      })
    },
    onReset() {
      this.$refs.searchForm.resetFields()
      this.searchForm = Object.assign({}, originOrderSearchFrom)
      this.filters = {}
      this.fetchOrderData(1)
    },
    clickView(row) {
      this.$router.push({
        name: 'OrderDetails',
        params: { orderId: row.id }
      })
    },
    editRemark() {
      this.editRemarkDialogVisiable = true
    },
    handleCurrentChange(val) {
      this.fetchOrderData(val)
    },
    fetchOrderData(page) {
      if (this.orderListLoading) return
      this.orderListLoading = true

      request({
        url: '/order-list',
        method: 'get',
        params: {
          page: page,
          order: this.order_by,
          ...this.filters,
          page_size: this.numOfOrders
        }
      })
        .then(response => {
          const data = response.data
          const meta = response.meta
          for (let i = 0; i < response.data.length; i++) {
            var obj = {}
            obj.id = response.data[i].id
            obj.orderId = response.data[i].out_trade_no
            obj.customerName = response.data[i].customer_name
            if (
              response.data[i].customer.wechat_auths.length &&
              response.data[i].customer.wechat_auths[0].user_info
            ) {
              obj.headimgurl =
                response.data[i].customer.wechat_auths[0].user_info[
                  'headimgurl'
                ]
              obj.wechatName =
                response.data[i].customer.wechat_auths[0].user_info['nickname']
            } else {
              obj.wechatName = ''
            }
            obj.shippingFee = this.formatPrice(response.data[i].express_fee)
            obj.totalFee = this.formatPrice(response.data[i].fee)
            obj.orderStatus = response.data[i].status_name
            // obj.message = response.data[i].message
            obj.orderCreateAt = response.data[i].created_at
            // obj.orderCreateAt = dayjs(
            //   new Date(obj.orderCreateAt + ' UTC')
            // ).format('YYYY-MM-DD HH:mm:ss')
            console.log(obj.orderCreateAt)
            obj.consignee = response.data[i].order_address.consignee_name
            obj.consigneePhone = response.data[i].order_address.phone
            obj.profit =
              response.data[i].profit !== 0
                ? this.formatPrice(response.data[i].profit)
                : ''

            data[i] = obj
          }
          this.orderData = data
          this.currentPage = meta.current_page
          this.currentTotal = meta.total

          this.orderListLoading = false
        })
        .catch(error => {
          console.warn(error)
          this.orderListLoading = false
        })
    }
  }
}
</script>

<style scoped>
.remark {
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 1rem;
  max-height: 3rem;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1rem;
  -webkit-line-clamp: 3;
}
</style>
